export default {
  /**
   * Parse a DateTime string to Unix timestamp
   *
   * @param {String} dateStr DateTime string to parse
   * @return {*} Unix timestamp of string
   */
  toUTCTimestamp(dateStr) {
    if (!dateStr) {
      return null;
    }

    const d = new Date(dateStr);

    return Math.floor(d.getTime() / 1000 + d.getTimezoneOffset() * 60);
  },
  /**
   * Create a promise which resolves after a period of time
   *
   * @param {*} ms  Time in ms to wait until resolving
   * @param {*} val Value of promise when resolved
   * @return {Promise<any>} Promise that will resolve after specified time
   */
  wait(ms, val) {
    return new Promise((res) => setTimeout(() => res(val), ms));
  },
  /**
   * Generate method to return to last page
   * Returned method should be bound to Vue instance
   *
   * @param {string} defaultLocation Default location to direct user to if no browser history
   *                 exists for window
   * @return {Function} Method to send user back one page
   */
  goBack(defaultLocation = '/') {
    return function() {
      /* eslint-disable no-invalid-this */
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push(defaultLocation);
      }
    };
  }
};

/**
 * Generate computed properties that watch values in URL querystring
 *
 * @param {Array<String> | {String: String}} params List or map of properties to map from
 * querystring
 * @return {*} Map of computed properties
 */
export function mapParams(params) {
  const computed = {};
  if (params instanceof Array) {
    for (const param of params) {
      computed[param] = function() {
        return this.$route ? this.$route.query[param] : null;
      };
    }
  } else {
    for (const param of Object.keys(params)) {
      computed[param] = function() {
        return this.$route ? this.$route.query[params[param]] : null;
      };
    }
  }

  return computed;
}
